/**
 * Component: MouseOverFeatures
 */

export default class MouseOverFeatures {
    constructor() {
        this.selectors = {
            root: 'section.mouse-over-features',
            point: 'button[data-mouse-over-features]',
            pointContent: 'div[data-mouse-over-features]',
            mobilePointContentContainer: 'div.mouse-over-features__feature-description-container.mobile--down'
        };

        this.setProperties();
        this.setNodeMapReference();
        this.initUI();
        this.setEventListeners();
    }

    setProperties() {
        this.root = document.querySelector(this.selectors.root);
        this.points = this.root.querySelectorAll(this.selectors.point);
        this.pointContents = Array.from(this.root.querySelectorAll(this.selectors.pointContent)).filter(_node => Boolean(_node.offsetParent));
        this.mobilePointContentContainer = this.root.querySelector(this.selectors.mobilePointContentContainer);
        this.pointNodeMap = {};
        this.activePoint = null;
    }

    // Precompute map for faster updates in updateActivePoint
    setNodeMapReference() {
        this.points.forEach(_point => {
            this.pointNodeMap[_point.dataset.mouseOverFeatures] = { control: _point };
        });

        this.pointContents.forEach(_point => {
            if (this.pointNodeMap[_point.dataset.mouseOverFeatures]) {
                this.pointNodeMap[_point.dataset.mouseOverFeatures].content = _point;
            }
        });
    }

    initUI() {
        // Set the height of the content area since children are pos: absolute
        if (this.mobilePointContentContainer) {
            const contentHeight = Array.from(this.pointContents).reduce((acc, _node) => Math.max(acc, _node.offsetHeight), 0);
            if (contentHeight) this.mobilePointContentContainer.style.height = contentHeight + 'px';
        }

        // Set/reset default active point
        this.activePoint = this.points[0].dataset.mouseOverFeatures;
        this.pointNodeMap[this.activePoint].control.classList.add('active');
        this.pointNodeMap[this.activePoint].content.classList.add('active');

        Object.keys(this.pointNodeMap).forEach(key => {
            if (key !== this.activePoint) {
                this.pointNodeMap[key].control.classList.remove('active');
                this.pointNodeMap[key].content.classList.remove('active');
            }
        });
    }


    updateActivePoint(e) {
        const activePoint = e.currentTarget.dataset.mouseOverFeatures;

        if (activePoint && activePoint !== this.activePoint) {
            this.pointNodeMap[activePoint].control.classList.add('active');
            this.pointNodeMap[activePoint].content.classList.add('active');
            this.pointNodeMap[this.activePoint].control.classList.remove('active');
            this.pointNodeMap[this.activePoint].content.classList.remove('active');
            this.activePoint = activePoint;
        }
    }

    handleWindowResize() {
        this.setProperties();
        this.setNodeMapReference();
        this.initUI();
    }

    setEventListeners() {
        this.points.forEach(_point => {
            _point.addEventListener('mouseenter', this.updateActivePoint.bind(this));
        });

        window.addEventListener('resize', this.handleWindowResize.bind(this));
    }
}
